/**
 * Comprime un'immagine lato client (canvas) per restare sotto una soglia di peso.
 * Ridimensiona a maxDimension e riduce la qualità JPEG finché non rientra in targetBytes.
 * Se non è un'immagine o la compressione fallisce, restituisce il file originale.
 */
export async function compressImage(file, { maxDimension = 2200, targetBytes = 4 * 1024 * 1024 } = {}) {
  if (!file || !file.type || !file.type.startsWith('image/')) return file;
  if (file.size <= targetBytes) return file;

  try {
    const dataUrl = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });

    const img = await new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => resolve(im);
      im.onerror = reject;
      im.src = dataUrl;
    });

    let width = img.naturalWidth || img.width;
    let height = img.naturalHeight || img.height;
    if (!width || !height) return file;

    if (Math.max(width, height) > maxDimension) {
      const scale = maxDimension / Math.max(width, height);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    // sfondo bianco per immagini con trasparenza (es. PNG) convertite in JPEG
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);

    let quality = 0.85;
    let blob = await new Promise((r) => canvas.toBlob(r, 'image/jpeg', quality));
    while (blob && blob.size > targetBytes && quality > 0.4) {
      quality -= 0.1;
      // eslint-disable-next-line no-await-in-loop
      blob = await new Promise((r) => canvas.toBlob(r, 'image/jpeg', quality));
    }

    if (!blob) return file;

    const baseName = (file.name || 'image').replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
  } catch {
    return file; // fallback: lascia gestire il limite al server
  }
}
